<template>
  <div class="mt2 rounded-md px-4 py2 space-x-4 lg:(px-8)">
    <NuxtImg src="/webcontent/competetion.svg" alt="Competetion" class="rounded-md" />
  </div>
</template>
